import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import _ from 'lodash';
import ValidateBusinessActivityModal from './ValidateBusinessActivityModal';
import * as c from '../../constant';
import * as actions from '../../actions';

function BusinessActivity({
  businessId,
  getBusinessActivityList,
  businessActivityList,
  validateBusinessActivity,
  getNecessaryFieldsList,
}) {
  const [viewUpdateForm, setViewUpdateForm] = useState(false);
  const [formData, setFormData] = useState('');

  useEffect(() => {
    getBusinessActivityList(businessId, () => {
      setViewUpdateForm(false);
    });
  }, []);

  const onValidateBusinessActivity = data => e => {
    e.preventDefault();
    const id = _.get(data, 'id');
    const args = {
      business_line_id: _.get(data, 'attributes.business_line_id'),
    };

    getNecessaryFieldsList(args, response =>
      _.isEmpty(_.get(response, 'data'))
        ? validateBusinessActivity(businessId, id, {}, () => {
            setViewUpdateForm(false);
            getBusinessActivityList(businessId);
          })
        : setViewUpdateForm(true, setFormData(data))
    );
  };

  const closeUpdateModal = () => {
    setViewUpdateForm(false);
  };

  const handleValidateBusinessActivity = data => e => {
    e.preventDefault();

    const businessActivityId = _.get(formData, 'id');
    const details = _.omit(data, 'business_line_id');

    ConfirmAlert(
      'Are you sure you want to validate this business activity?',
      () => {
        const args = {
          details: { ...details },
        };
        validateBusinessActivity(businessId, businessActivityId, args, () => {
          setViewUpdateForm(false);
          getBusinessActivityList(businessId);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div>
      <div className="row">
        <div className="col-12">
          {viewUpdateForm === true && (
            <ValidateBusinessActivityModal
              closeUpdateModal={closeUpdateModal}
              businessActivityInfo={formData}
              handleValidateBusinessActivity={handleValidateBusinessActivity}
              setViewUpdateForm={setViewUpdateForm}
              businessId={businessId}
            />
          )}
        </div>
      </div>
      <div className="row">
        {businessActivityList.map(item => {
          return (
            <div key={item.id} className="col-6 form-group">
              <div className="form-wrapper p-3">
                <div className="text-right">
                  {viewUpdateForm === false && (
                    <button
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary    "
                      type="button"
                      onClick={onValidateBusinessActivity(item)}
                    >
                      Validate
                    </button>
                  )}
                </div>
                <div className="">
                  <label className="text-primary font-weight-bold mr-2">
                    Name:
                  </label>
                  <b>{_.get(item, 'attributes.name')}</b>
                </div>
                <div className="">
                  <label className="text-primary font-weight-bold mr-2">
                    Status:
                  </label>
                  <b>
                    {_.get(item, 'attributes.is_validated')
                      ? 'Validated'
                      : 'For Validation'}
                  </b>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

BusinessActivity.propTypes = {
  businessId: PropTypes.string.isRequired,
  getBusinessActivityList: PropTypes.instanceOf(Function).isRequired,
  businessActivityList: PropTypes.instanceOf(Array).isRequired,
  validateBusinessActivity: PropTypes.instanceOf(Function).isRequired,
  getNecessaryFieldsList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  businessActivityList:
    _.get(api, `${c.GET_BUSINESS_ACTIVITY_LIST}.list`) || [],
  necessaryFieldsList: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BusinessActivity);
